// extracted by mini-css-extract-plugin
module.exports = {"userMenuWrapper":"UserMenu_userMenuWrapper__38drE","userMenu":"UserMenu_userMenu__RecPU","text":"UserMenu_text__3nen-","menuItem":"UserMenu_menuItem__17KYP"};